export default function () {

  const widgetName = 'swiperWidgetGallery1';
  const widgetOpts = swiperWidgetGallery1Opts;

  const sizeWind = $(window).width();
  let animationCard = ""
  let animationSlide = ""


  if (sizeWind < 801) {
    animationSlide = `data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-duration="800" data-aos-delay="200" data-aos-once="true"`
    animationCard = `data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-duration="800" data-aos-delay="100" data-aos-once="true" data-aos-offset="270"`
  } else {
    animationSlide = `data-aos="fade-left" data-aos-easing="ease-in-out" data-aos-duration="800" data-aos-delay="500" data-aos-once="true"`
    animationCard = `data-aos="fade-left" data-aos-easing="ease-in-out" data-aos-duration="800" data-aos-delay="1000" data-aos-once="true"`
  }

  const swiperContainers = `
    <div class="swiper-container" ${animationSlide}>
        <div class="swiper-wrapper">
        </div>
        <div class="swiper-pagination"></div>
    </div>
  `;


  // Slide Template
  function buildSlideTemplate(slide) {

    const prevButton = `
    <div class="swiper-button-prev" tabindex="0" role="button" aria-label="Previous slide">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160zm352-160l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 438.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z"/></svg>
    </div>`

    const nextButton = `
    <div class="swiper-button-next" tabindex="0" role="button" aria-label="Next slide">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"/></svg>
    </div>`


    const template = `
      <div class="swiper-slide" >
              <div class="swiper-image-container swiper-lazy" data-background="${slide.ImageWithPath}" aria-label="${slide.ImageAlternateText}">
        ${prevButton}
      ${nextButton}
          <div class="swiper-lazy-preloader">
          </div>
        </div>
      </div>
    `;

    return template;
  }


  // Swiper Initialization
  function initSwiper(widgetData) {
    const swiperWidgetWrapper = $(`#${widgetName} .swiper-wrapper`);


    widgetData.forEach(function (slide, i) {
      swiperWidgetWrapper.append(buildSlideTemplate(slide));

      if (i === 0) {
        function createContentTextGallery(slide) {
          const content = `
      <div class="container-back"  ${animationCard}>
      <div class="gallery-content">
        <h2>${slide.Title}</h2>
        <p>${slide.Description}</p>
        <a href="${slide.URL}" class="button">Learn More</a>
     </div>
     </div>
     `;
          $(content).appendTo(".gallery-content-text")
        }
        createContentTextGallery(slide)
      }
    });

    const swiperWidget = new Swiper(`#${widgetName} .swiper-container`, {
      speed: 600,
      autoplay: {
        delay: 6000,
      },
      // autoplay:false
      spaceBetween: 0,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      navigation: {
        nextEl: `#${widgetName} .swiper-button-next`,
        prevEl: `#${widgetName} .swiper-button-prev`,
      },
      centeredSlides: false,
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1
      },
      a11y: true,
      autoHeight: false,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      }
    });

  }


  // Fetch data and initialize widget
  saffire.utils.getWidgetData(widgetOpts).then(function (response) {
    if (response.Slides.length > 0) {
      $(`#${widgetName}`).html(swiperContainers);
      initSwiper(response.Slides);
    } else {
      // console.log(response);
      console.log('Error: No Data for swiperWidget');
    }
  });

}
